function loadConfig() {
  return fetch(`/config/${window.location.hostname}.json`)
    .then(response => response.json())
    .then(config => {
      window.ReactAppEnv = config;
      window.ReactAppEnv.version = import.meta.env.VITE_BUILD_VERSION;
    })
    .catch(e => {
      console.error('Unable to download app environment config.');
      console.error(e);      
    });
}

Promise.all([
  import('./AppPreload'),
  loadConfig(),
]).then(([{
  App,
  createHistory,
  initializeStats,
  Router,
  React,
  ReactDOM,
  Suspense,  
}]) => {
  const history = createHistory();

  if (window.ReactAppEnv && window.ReactAppEnv.stats && window.ReactAppEnv.stats.gaTrackingId) {
    initializeStats(window.ReactAppEnv.stats.gaTrackingId, window.location.pathname, history);
  }

  ReactDOM.render(
    <Router history={history}>
      <App />
    </Router>
, document.getElementById('root')
  );
});
